'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$6() {
  this.blG = null;
  this.blE = null;
  this.blF = false;
  this.blC = null;
  this.blD = false;
  this.blH = false;
  this.blI = false;
  this.blG = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
}
export { $c_Lpresto_PrestoRouter$$anon$6 as $c_Lpresto_PrestoRouter$$anon$6 };
$p = $c_Lpresto_PrestoRouter$$anon$6.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$6;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$6() {
}
export { $h_Lpresto_PrestoRouter$$anon$6 as $h_Lpresto_PrestoRouter$$anon$6 };
$h_Lpresto_PrestoRouter$$anon$6.prototype = $p;
$p.a1 = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Encoder$AsObject__apply__O__Lio_circe_Json(this, a);
});
$p.af = (function() {
  return this.blG;
});
$p.t = (function() {
  if ((!this.blF)) {
    this.blE = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.blF = true;
  }
  return this.blE;
});
$p.ag = (function() {
  if ((!this.blD)) {
    this.blC = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.blD = true;
  }
  return this.blC;
});
$p.v = (function() {
  if ((!this.blI)) {
    this.blH = false;
    this.blI = true;
  }
  return this.blH;
});
$p.ae = (function(a) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredEncoder__encodeProduct__O__Lio_circe_JsonObject(this, a);
});
var $d_Lpresto_PrestoRouter$$anon$6 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$6, "presto.PrestoRouter$$anon$6", ({
  OA: 1,
  a: 1,
  l: 1,
  n: 1,
  o: 1,
  p: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$6 as $d_Lpresto_PrestoRouter$$anon$6 };
//# sourceMappingURL=presto.-Presto-Router$$anon$6.js.map
